module.exports = __webpack_public_path__ + "static/media/slick.d41f55a7.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/slick-carousel/slick/fonts/slick.ttf
// module id = 184
// module chunks = 0